import UserRoleSerializer from "./UserRoleSerializer";
import RegionSerializer from "./RegionSerializer";

export default class UserSerializer {
  static serialize(data) {
    return {
      userObjectId: data.userId,
      userName: data.userName,
      roleId: data.roleId,
      regionId: data.regionId,
      isActive: data.isActive,
      dateCreated: data.dateCreated,
      dateModified: data.dateModified,
      userIdMcld: data.userIdMcld,
      region: RegionSerializer.serialize(data.region),
      role: UserRoleSerializer.serialize(data.role),
      email: data.email
    };
  }

  static deSerialize(data) {
    return {
      userId: data.userObjectId,
      userName: data.userName,
      roleId: data.roleId,
      regionId: data.regionId,
      isActive: data.isActive,
      dateCreated: data.dateCreated,
      dateModified: data.dateModified,
      userIdMcld: data.userIdMcld && data.userIdMcld.trim(),
      region: RegionSerializer.deSerialize(data.region),
      role: UserRoleSerializer.deSerialize(data.role),
      email: data.email
    };
  }
}